import h1_img from '../hideamic/h1.jpg'
import h2_img from '../hideamic/h2.jpg'
import h3_img from '../hideamic/h3.jpg'
import h4_img from '../hideamic/h4.jpg'
import h5_img from '../hideamic/h5.jpg'
import h6_img from '../hideamic/h6.jpg'
import h7_img from '../hideamic/h7.jpg'
import h8_img from '../hideamic/h8.jpg'
import h9_img from '../hideamic/h9.jpg'
import h10_img from '../hideamic/h10.jpg'
import h11_img from '../hideamic/h11.jpg'
import h12_img from '../hideamic/h12.jpg'
import h13_img from '../hideamic/h13.jpg'
import h14_img from '../hideamic/h14.jpg'
import h15_img from '../hideamic/h15.jpg'
import h16_img from '../hideamic/h16.jpg'
import h17_img from '../hideamic/h17.jpg'
import h18_img from '../hideamic/h18.jpg'
import h19_img from '../hideamic/h19.jpg'
import h20_img from '../hideamic/h20.jpg'
import h21_img from '../hideamic/h21.jpg'
import h22_img from '../hideamic/h22.jpg'
import h23_img from '../hideamic/h23.jpg'
import h24_img from '../hideamic/h24.jpg'

import w1_img from '../radius windshield/w1.jpg'
import w2_img from '../radius windshield/w2.jpg'
import w3_img from '../radius windshield/w3.jpg'
import w5_img from '../radius windshield/w5.jpg'
import w7_img from '../radius windshield/w7.jpg'
import w8_img from '../radius windshield/w8.jpg'
import w9_img from '../radius windshield/w9.jpg'
import w10_img from '../radius windshield/w10.jpg'
import w11_img from '../radius windshield/w11.jpg'
import w12_img from '../radius windshield/w12.jpg'
import w13_img from '../radius windshield/w13.jpg'
import w15_img from '../radius windshield/w15.jpg'
import w16_img from '../radius windshield/w16.jpg'
import w17_img from '../radius windshield/w17.jpg'
import w18_img from '../radius windshield/w18.jpg'
import w19_img from '../radius windshield/w19.jpg'
import w20_img from '../radius windshield/w20.jpg'
import w21_img from '../radius windshield/w21.webp'
import w22_img from '../radius windshield/w22.webp'
import w23_img from '../radius windshield/w23.webp'
import w25_img from '../radius windshield/w25.webp'
import w26_img from '../radius windshield/w26.webp'
import w27_img from '../radius windshield/w27.webp'
import w28_img from '../radius windshield/w28.webp'
import w29_img from '../radius windshield/w29.webp'
import w30_img from '../radius windshield/w30.webp'
import w31_img from '../radius windshield/w31.webp'
import w32_img from '../radius windshield/w32.webp'
import w33_img from '../radius windshield/w33.webp'
import w34_img from '../radius windshield/w34.webp'
import w35_img from '../radius windshield/w35.webp'
import w36_img from '../radius windshield/w36.webp'
import w37_img from '../radius windshield/w37.webp'
import w38_img from '../radius windshield/w38.webp'
import w39_img from '../radius windshield/w39.webp'
import w40_img from '../radius windshield/w40.webp'
import w41_img from '../radius windshield/w41.webp'
import w42_img from '../radius windshield/w42.webp'
import w43_img from '../radius windshield/w43.webp'
import w46_img from '../radius windshield/w46.webp'
import w45_img from '../radius windshield/w45.webp'
import w47_img from '../radius windshield/w47.webp'
import w48_img from '../radius windshield/w48.webp'

import u2_img from '../ursa/u2.jpg'
import u3_img from '../ursa/u3.jpg'
import u4_img from '../ursa/u4.jpg'
import u5_img from '../ursa/u5.jpg'
import u6_img from '../ursa/u6.jpg'
import u8_img from '../ursa/u8.jpg'
// import u9_img from '../ursa/u9.jpg'
import u10_img from '../ursa/u10.jpg'
import u11_img from '../ursa/u11.jpg'
import u12_img from '../ursa/u12.jpg'
import u13_img from '../ursa/u13.jpg'
import u14_img from '../ursa/u14.jpg'
import u18_img from '../ursa/u18.jpg'
import u19_img from '../ursa/u19.jpg'
import u20_img from '../ursa/u20.jpg'
import u21_img from '../ursa/u21.jpg'
import u22_img from '../ursa/u22.jpg'
import u23_img from '../ursa/u23.jpg'
import u24_img from '../ursa/u24.jpg'
import u25_img from '../ursa/u25.jpg'
import u26_img from '../ursa/u26.jpg'
import u27_img from '../ursa/u27.jpg'
import u28_img from '../ursa/u28.jpg'
import u29_img from '../ursa/u29.jpg'
import u33_img from '../ursa/u33.jpg'
import u34_img from '../ursa/u34.jpg'
import u35_img from '../ursa/u35.jpg'
import u36_img from '../ursa/u36.jpg'
import u37_img from '../ursa/u37.jpg'
import u38_img from '../ursa/u38.webp'
import u39_img from '../ursa/u39.webp'
import u41_img from '../ursa/u41.webp'
import u40_img from '../ursa/u40.webp'
import u42_img from '../ursa/U42.webp'
import u43_img from '../ursa/U43.webp'
import u44_img from '../ursa/u44.webp'
import u45_img from '../ursa/u45.webp'
import u46_img from '../ursa/u46.webp'
import u47_img from '../ursa/u47.webp'
import u48_img from '../ursa/u48.webp'
import u49_img from '../ursa/u49.webp'
import u50_img from '../ursa/u50.webp'
import u51_img from '../ursa/u51.webp'
import u52_img from '../ursa/u52.webp'
import u53_img from '../ursa/u53.webp'
import u54_img from '../ursa/u54.webp'
import u55_img from '../ursa/u55.webp'
import u56_img from '../ursa/u56.webp'
import u57_img from '../ursa/u57.webp'
import u58_img from '../ursa/u58.webp'
import u59_img from '../ursa/u59.webp'
import u60_img from '../ursa/u60.webp'
import u61_img from '../ursa/u61.webp'
import u62_img from '../ursa/u62.webp'
import u63_img from '../ursa/u63.webp'

import v1_img from "../viviana/v1.jpg"
import v2_img from "../viviana/v2.jpg"
import v3_img from "../viviana/v3.jpg"
import v4_img from "../viviana/v4.jpg"
import v5_img from "../viviana/v5.jpg"
import v6_img from "../viviana/v6.jpg"
import v8_img from "../viviana/v8.jpg"
import v10_img from "../viviana/v10.jpg"
import v12_img from "../viviana/v12.jpg"
import v13_img from "../viviana/v13.jpg"
import v15_img from "../viviana/v15.jpg"
import v16_img from "../viviana/v16.jpg"
import v17_img from "../viviana/v17.jpg"
import v19_img from "../viviana/v19.jpg"
import v22_img from "../viviana/v22.jpg"
import v23_img from "../viviana/v23.jpg"
import v24_img from "../viviana/v24.jpg"
import v25_img from "../viviana/v25.jpg"
import v26_img from "../viviana/v26.jpg"
import v28_img from "../viviana/v28.jpg"
import v30_img from "../viviana/v30.jpg"
import v31_img from "../viviana/v31.jpg"
import v32_img from "../viviana/v32.jpg"
import v33_img from "../viviana/v33.jpg"

import e2_img from '../homepage/e2.jpg'
import e3_img from '../homepage/e3.jpg'
import e4_img from '../homepage/e4.jpg'
import e10_img from '../homepage/e10.jpg'
import e12_img from '../homepage/e12.jpg'
import e34_img from '../homepage/e34.jpg'
import e36_img from '../homepage/e36.jpg'
import e42_img from '../homepage/e42.jpg'
import e45_img from '../homepage/e45.jpg'
import e53_img from '../homepage/e53.jpg'
import e51_img from '../homepage/e51.jpg'
import e52_img from '../homepage/e52.jpg'
import e55_img from '../homepage/e55.jpg'
import e54_img from '../homepage/e54.jpg'
import e56_img from '../homepage/e56.jpg'
import e61_img from '../homepage/e61.jpg'

import c1_img from '../coss11/c1.jpg'
import c2_img from '../coss11/c2.jpg'
import c3_img from '../coss11/c3.jpg'
import c4_img from '../coss11/c4.jpg'


let all_product = [
    {
        category: "hideamic",
        id: 1,
        name: "Hide-a-mic Scilencer Set",
        image:
            h1_img,
        sideimg: [
            h1_img,
            h2_img,
            h3_img
        ],
        price: 2950,
        desc: `
Hide-a-mic Silencer Set uses 3mm industrial foam with 3M adhesive to cut surface-to-surface noise on set. Tough and non-slip, it works as shoe silencers and is easy to remove. Each set includes 6 sheets (102 stickers) in black, brown, or white. Benefits include reducing footsteps and object noise, improving dialogue clarity, allowing filming in challenging locations, and minimizing distractions for actors—delivering cleaner, professional-grade sound.`,
    },
    {
        category: "hideamic",
        id: 2,
        name: "Hide-a-mic Tie Holder",
        image:
            h7_img,
        price: 2596,
        desc: `Available Colors :- Black and Transparent

Tie-holder – The Tie-holders is the basis of Hide-a-mic. You run the microphone from the back of the tie down through the knot. Then apply the holder and push it back in the knot. Secure it with a Hide-a-mic Sili-pad and you are ready to roll.1`,
    },
    {
        category: "hideamic",
        id: 3,
        name: "Hide-a-mic Bra Holder",
        image:
            h4_img,
        sideimg: [
            h4_img,
            h5_img,
            h6_img
        ],
        price: 2596,
        desc: `HIDE A MIC BRA HOLDER As a soundmixer you are always busy looking for the best place to hide a miniature microphone. The bra is usually a great place to hide microphones but nowadays placing microphones there can be a charged topic. It can cause awkward situations for both the female talent/host and the sound mixer on duty. The Hide-a-mic Bra-clip can easily be self-applied by the talent/host and will produce clear sound for your recordings throughout the day; without any need for adjustments. No more awkward situations, insinuations and expectations on set, exactly how it’s should be in a professional environment DPA 4060/71 DPA 6060/61 SANKEN COS 11`,
    },
    {
        category: "radius",
        id: 4,
        name: "Mini-alto 180 & RAD-2 Kit",
        image:
            w8_img,
        sideimg: [
            w3_img,
            w2_img,
            w5_img,
            w7_img
        ],
        price: 67260,
        desc: `Mini-ALTO & RAD-2 Kit is a compact, professional windshield and shock mount system for small and shotgun mics. It includes the RAD-2 shock mount for superior noise isolation, a lightweight 2-part magnetic pod windshield, and a removable fur cover offering up to -40dB wind reduction. At just 85mm in diameter, it’s the smallest full-coverage zeppelin available, yet performs like larger models. The kit comes with the windshield, RAD-2 mount, four suspension hoop sets, fur cover, “smiley face” adaptor, magnetic stowage holder with carabiner, RAD cable straps, and optional custom XLR cable. Compatible with mics like DPA4017C, Neumann KM184, Rode NT5, Sanken CS-M1, Schoeps CMC series, and Sennheiser MKH50. Made in the U.K.`,
    },
    {
        category: "radius",
        id: 5,
        name: "Mini-alto 210 & RAD-2 Kit",
        image:
            w1_img,
        sideimg: [
            w3_img,
            w8_img,
            w5_img,
            w7_img
        ],
        price: 67260,
        desc: `Mini-ALTO & RAD-2 Kit is a lightweight, professional windshield and shock mount system for small, short, and standard shotgun mics. It includes the award-winning RAD-2 shock mount, a quick-fit 2-part magnetic pod windshield, and a removable fur cover that delivers up to -40dB wind reduction. At just 85mm in diameter, it’s the smallest full-coverage zeppelin available, combining compact size with pro-level performance. The kit features the windshield, RAD-2 mount with 4 suspension hoop sets, fur cover, “smiley face” adaptor, magnetic stowage holder with carabiner, RAD cable straps, and optional custom 3-pin XLR cable. Compatible with mics like DPA 2017, Sanken CS-1e, and Sennheiser MKH8060. Made in the U.K.`,
    },


    {
        category: "radius",
        id: 6,
        name: "12cm Shotgun Mic Foam (19/22)",
        image:
            w9_img,
        sideimg: [
            w9_img,
            w11_img,
            w10_img,
        ],
        price: 2950,
        desc: `12cm Shotgun Mic Foam (19/22) by Radius is a high-quality acoustic foam designed to block plosives, swooshes, and light wind noise without affecting high frequencies. Made in the U.K. from durable semi-open cell material, it resists UV and moisture, unlike cheap foams that degrade quickly. The tapered design offers extra side protection near the capsule while maintaining transparency at the front. Compatible with 19–22mm diameter short shotguns and camera mics (slots <12cm from the end), including models from Audio Technica, DPA, Schoeps, Sennheiser, and Sony. Specs: external length 150mm, internal length 120mm, width 55mm.`,
    },
    {
        category: "radius",
        id: 7,
        name: "12cm Shotgun Mic Foam (15cm)",
        image:
            w12_img,
        sideimg: [
            w12_img,
            w11_img,
            w13_img,
        ],
        price: 2950,
        desc: `15cm Shotgun Mic Foam (19/22) from Radius is crafted from premium acoustic foam to reduce plosives, boom swooshes, and light wind noise while preserving high-frequency clarity. Made in the U.K. with UV- and moisture-resistant semi-open cell material, it’s far more durable than standard foams. The tapered design offers added side protection near the capsule and transparency at the interference tube. Suitable for 19–22mm shotgun mics with slots <15cm from the end, including Audio-Technica AT897/BP4029, Neumann KMR 81i, Rode NTG-1/NTG-2, Sanken CS-1e/CSS-50, Sennheiser MKE600, and Schoeps CMIT 5.`,
    },
    {
        category: "radius",
        id: 8,
        name: "MKH 50 ",
        image:
            w15_img,
        sideimg: [
            w15_img,
            w16_img,
            w17_img,
        ],
        price: 2360,
        desc: `MKH50 Mic Foam by Radius is a premium acoustic foam designed to block plosives, swooshes, and light wind noise without compromising high-frequency clarity. Made in the U.K. from UV- and moisture-resistant semi-open cell material, it’s far more durable than standard foams. The tapered design enhances side protection near the capsule while maintaining transparency at the front. Fits Sennheiser MKH20/30/40/50 and Sony ECM-MS2, as well as other 24–25mm small pencil condenser and instrument mics with slots under 5cm from the tip.`,
    },
    {
        category: "radius",
        id: 9,
        name: "RAD Mount Pistol Grip Handle",
        image:
            w18_img,
        sideimg: [
            w18_img,
            w19_img,
            w20_img,
        ],
        price: 5310,
        desc: `RAD Mount Pistol Grip Handle The RAD Mount Pistol Grip Handle is designed to attach to the RAD Mount top bracket and thumbwheel. This handle can be swapped out with a RAD-1 or RAD-2 boom adaptor to use for handheld recording. It also has a 3/8 threaded bottom so it can fit on boom poles, stand or used with a quick-connect attachment. The handle has a rubber coated embedded XLR holder with a rubber safety strap to keep the XLR socket securely fitted inside.`,
    },
    {
        category: "radius",
        id: 10,
        name: "Radius mini alto 115",
        image:
            w21_img,
        sideimg: [
            w21_img,
            w23_img,
            w22_img,
        ],
        price: 67260,
        desc: `Mini-ALTO 115 size windshield, RAD-2 Shock Mount with 4 pairs of suspension hoops (extra soft, soft, standard, extra firm), Fur Windcover, Smiley Face Adaptor, Magnetic Windshield Stowage Holder with Carabiner Clip, a pair of RAD Cable Straps and (optional) 3-Pin XLR cable.

'Fits: DPA 4018C; Neumann KM 100 Series; Schoeps CMC1 Series; Sennheiser MKH8020; MKH8030; MKH8040; MKH8050`,
    },
    {
        category: "radius",
        id: 11,
        name: "Radius Mini-ALTO 300",
        image:
            w25_img,
        sideimg: [
            w25_img,
            w26_img,
            w27_img,
        ],
        price: 73750,
        desc: `The Mini-ALTO 250 / 280 / 300 windshield kits come in full kits which include the windshield, a RAD-2 Mount, spare hoops with different suspension firmness, a fur windcover, a "smiley face" adaptor, pistol grip handle and a magnetic stowage holder for the windshield with a caribiner clip. The full kits are available in versions with and without custom fitted XLR cables. Made in the U.K.

Fits: Audio-Technica AT897; Rode NTG2, NTG3, NTG4+; Sanken CS-3e; Schoeps CMIT 5 (with straight XLR), Super CMIT; Sennheiser MKE600, MKH416 (with straight XLR), MKH60; Sony ECM-674
`,
    },
    {
        category: "radius",
        id: 12,
        name: "RAD-2 Field Edition Shock Mount(Pair)",
        image:
            w28_img,
        sideimg: [
            w28_img,
            w29_img,
            w30_img,
        ],
        price: 15930,
        desc: `The RAD-2 Field Edition Shock Mounts are designed for use with small condenser microphones used on stands or other mounts for field recording. It provides exceptional isolation from movement and other vibrations. The Field Edition mount comes with 3 sizes of mic clips -- a pair of 19-21mm clips, a pair of 12.5-14.5mm clips and an individual 8mm (for Lemo or MZL connectors). Each mount also includes 3 pairs of suspension hoops with different levels of firmness -- standard, soft and extra soft. The suspension hoops can be spaced at 25mm or 15mm apart on the mounting bracket. The bracket also has a cable retention clip at the base and an optional one that can be mounted on the top. The mount has a 3/8 female threaded base. The Field Edition mounts are made from virtually indestructible material. Made in the U.K.`,
    },
    {
        category: "radius",
        id: 13,
        name: "Pair of RAD Universal Mic Clips ",
        image:
            w31_img,
        price: 4720,
        desc: `Pair of RAD universal mic clips to fit on RAD isolation hoops. These clips will fit microphones with a diameter of 19-25mm, including square bodied mics. The insides have soft rubber lining to grip mics securely whilst not damaging the finish. The mic clips come with removable rubber straps to hold mics securely in place when needed. This product consists of mic clips only - does not come with isolation hoops.`,
    },
    {
        category: "radius",
        id: 14,
        name: "18cm Shotgun Mic Foam (19/22)",
        image:
            w32_img,
        price: 2950,
        desc: `ChatGPT said:

Radius Shotgun Mic Foams are high-quality acoustic foams built to reduce plosives, swooshes, and light wind noise while preserving high-frequency detail. Made in the U.K. from durable semi-open cell material resistant to UV and moisture, they outlast standard foams that degrade quickly. The tapered design provides extra side protection near the capsule and transparency at the interference tube. Available in multiple sizes, they fit 19–22mm shotgun mics with slots under 18cm from the tip, making them ideal for broadcast, camera, and recording use.`,
    },
    {
        category: "radius",
        id: 15,
        name: "MKH60 Shotgun Mic Foam",
        image:
            w32_img,
        price: 2950,
        desc: `
Radius Mic Foams are premium acoustic foams designed to block plosives, swooshes, and light wind noise while maintaining high-frequency clarity. Made in the U.K. from durable semi-open cell material resistant to UV and moisture, they outperform standard foams that degrade quickly. The tapered shape adds side protection near the capsule and transparency at the interference tube. Suitable for Sennheiser MKH60 and other 24–25mm shotgun mics with slots under 18cm from the tip, making them ideal for broadcast, film, and recording applications.`,
    },
    {
        id: 16,
        category: "ursa",
        name: "Ursa ANKLE Strap (SPLIT END)",
        image:
            u53_img,
        sideimg: [
            u53_img,
            u54_img,
            u55_img,
            
        ],
        price: 5605,
        desc: `The Ankle Strap has been upgraded. The new Split End design allows each end to stretch independently, giving you a stronger, more comfortable fit around the Ankle or Calf. This improvement makes the strap easier to apply, more secure during movement, and even more versatile.

The new length is 42cm – that’s 3cm longer than the original Ankle Strap – for added flexibility. Please note, the previous version without the Split End will no longer be available.
Crafted with our unique bonded fabric technology, the strap is:
Soft against the skin
Ultra-breathable
Allows the hook gripper to fasten at any point for a perfect fit
The built-in universal pouch securely holds all standard transmitters, with added features including:
Internal gripper to keep transmitters stable
Cable pocket & strain relief slit for managing excess cable
Pouch protector flap to keep your TX in place
Available in four colours – Beige, White, Black & Caramel – to blend discreetly with costumes or skin tones.
One pouch size fits all transmitters. See our transmitter guide for compatibility.`,
    }, {
        id: 17,
        category: "ursa",
        name: "Ursa Medium Waist",
        image:
            u6_img,
        sideimg:
            [u2_img,
                u6_img,
            ],
        price: 5605,
        desc: `URSA Straps Medium Waist Transmitter Belt URSA Waist Straps feature a low-profile velcro, curved strap design, and have a built-in Cable Pocket. In order to make the most comfortable low-profile straps URSA developed a brand new bonded fabric. URSA straps are just 1mm thick. Size :- 100cm`
    },
    {
        id: 18,
        category: "ursa",
        name: "Ursa Thigh Strap",
        image:
            u3_img,
        sideimg: [
            u3_img,
            u34_img
        ],
        price: 5605,
        desc: `URSA Straps Thigh Transmitter Belt URSA Thigh Straps feature a low-profile velcro, curved strap design, and have a built-in Cable Pocket. In order to make the most comfortable low-profile straps URSA developed a brand new bonded fabric. URSA straps are just 1mm thick. They provide excellent stretch, comfort and breathability with an outer surface that hook Velcro can grip to at any point. Thigh strap length is from 37cm to 67cm (14 to 26 Inches). Available in Beige and Black colour Features Designed to fit most popular transmitters Unique polyurethane gripper keeps the strap from slipping Built-in cable pocket secures your looped cable Ultra low profile fabric is only 1mm thick`,
    },
    {
        id: 19,
        category: "ursa",
        name: "Ursa Chest Strap",
        image:
            u4_img,
        sideimg: [
            u4_img,
            u35_img
        ],
        price: 5605,
        desc: `URSA Straps Chest Strap for Lavalier URSA Chest Straps allow you to rig microphones onto sweaty or hairy chests which would otherwise not take sticky tape. Our unique polyurethane gripper is bonded on to keep the straps from slipping. We also utilise a Cable Keeper which keeps your cable firmly in place without needing to tape it to the strap. In order to make the most comfortable low-profile straps URSA developed a brand new bonded fabric. URSA straps are just 1mm thick. They provide excellent stretch, comfort and breathability with an outer surface that hook Velcro can grip to at any point. Available in Beige colour only Designed to fit most popular lavalier microphones Unique polyurethane gripper keeps the strap from slipping Built-in cable pocket secures your looped cable Ultra low profile fabric is only 1mm thick`,
    },
    {
        id: 20,
        category: "ursa",
        name: "Ursa Large Waist Straps",
        image:
            u5_img,
        sideimg: [
            u5_img,
            u8_img
        ],
        price: 5605,
        desc: `URSA Straps Chest Strap for Lavalier URSA Straps Large Waist Transmitter Belt URSA Waist Straps feature a low-profile velcro, curved strap design, and have a built-in Cable Pocket. In order to make the most comfortable low-profile straps URSA developed a brand new bonded fabric. URSA straps are just 1mm thick. Size :- 120cm`,
    },
    // {
    //     id: 21,
    //     category: "ursa",
    //     name: "Ursa Calf Straps",
    //     image:
    //         u9_img,
    //     price: 5192,
    //     desc: `URSA Straps Calf Transmitter Belt URSA Calf Straps feature a low-profile velcro, curved strap design, and have a built-in Cable Pocket. In order to make the most comfortable low-profile straps URSA developed a brand new bonded fabric. URSA straps are just 1mm thick. They provide excellent stretch, comfort and breathability with an outer surface that hook Velcro can grip to at any point. Provides excellent support for this strap around the Calf or the Ankle. Perfect for rigging transmitters higher up the leg without risk of them slipping down into shot. It’s especially useful for stunts or action sequences. Features Designed to fit most popular transmitters Unique polyurethane gripper keeps the strap from slipping Built-in cable pocket secures your looped cable Ultra low profile fabric is only 1mm thick Perfect for rigging transmitters to the calf or the ankle The Calf Strap measures 76cm and features a Big Pouch, see below for pouch size guide Available in Beige Only`,
    // },
    {
        id: 22,
        name: "Ursa Fur Circle",
        image:
            u10_img,
        price: 2596,
        desc: `More About URSA Fur Circles Fur Circles are reusable up to 4 or 5 times. Can be stuck directly to skin or clothes. Single Colour 9 Packs contain 9 of one colour & 30 Stickies. Single Colour 100 Packs contain 100 of one colour only. Multipacks contain 3x White, 3x Black, 3x Brown & 30 Stickies. Available colours : Black, White & Brown. 25mm diameter, re-useable & super soft. Low profile lav cover creates less of a lump under costumes`,
    },
    {
        id: 23,
        category: "ursa",
        name: "Ursa Soft Circle",
        image:
            u11_img,
        price: 1888,
        desc: `More About URSA Soft Circles Stretchy fabric allows allows the fabric to be wrapped around mounts to provide wind protection. Multipacks contain 5x White, 5x Black, 5x Beige & 30 Stickies. Single Colour 15 Packs contain 15 of one colour & 30 Stickies. Single Colour 100 Packs contain 100 of one colour only. Available in 6 colours : Black, White, Beige, Brown, Chroma Green & Chroma Blue. 25mm diameter circles, re-useable & super soft. Low profile lav cover creates less of a lump under costumes.`,
    },
    {
        id: 24,
        category: "ursa",
        name: "Ursa Plush Circle",
        image:
            u12_img,
        price: 2596,
        desc: `More About URSA Plush Circles Multipacks contain 3x White, 3x Black, 3x Beige & 30 Stickies. Single Colour 9 Packs contain 9 of one colour & 30 Stickies. Single Colour 100 Packs contain 100 of one colour only. Available in 4 colours : Black, White, Beige & Brown. 25mm diameter, re-useable & super soft Low profile lav cover creates less of a lump under costumes.`,
    },
    {
        id: 25,
        category: "ursa",
        name: "Ursa Very Stickies",
        image:
            u13_img,
        price: 2714,
        desc: `More About URSA Very Sticky Circles URSA Very Sticky Circles (Pack of 90) Each 24mm diameter URSA Very Sticky Circle has been pre-cut and has a small peel-off tab for easy & fast use. They are compatible with a variety of mic mounts including RM11s, DPA Concealers and can also be used with URSA MiniMounts.`,
    },
    {
        id: 26,
        category: "ursa",
        name: "Ursa Sticky Circle",
        image:
            u14_img,

        price: 2714,
        desc: `More About URSA Sticky Circles URSA Sticky Circles (Pack of 90) Each 24mm diameter URSA Sticky Circle has been pre-cut and has a small peel-off tab for easy & fast use. They are compatible with a variety of mic mounts including RM11s, DPA Concealers and can also be used with URSA MiniMounts. (You get 30 of these stickies with every pack of URSA Plush, Fur or Soft Circles)`,
    },
    {
        id: 27,
        category: "ursa",
        name: "Ursa Foamies Pro",
        image:
            u38_img,
        sideimg: [
            u39_img,
            u41_img,
            u40_img,
        ],
        price: 2596,
        desc: ` URSA Foamie Pro and Mini Foamie Pro!
Made from an incredibly soft, silky-smooth premium foam, the new Foamie Pros deliver the quietest microphone rigs ever. They’re softer, quieter, and more durable than our original Foamies – all while remaining at the same price. The upgraded, high-quality foam feels luxuriously smooth while offering improved durability and reusability.
Unlike the classic Foamies, the new material allows you to apply and remove sticky tape without tearing or damaging the foam – meaning each Foamie can be used multiple times, making them more sustainable, eco-friendly, and cost-effective.
Designed for Every Setup
PACK OF 12`,
    },
    {
        id: 28,
        category: "ursa",
        name: "Ursa Mini Foamies",
        image:
            u18_img,
        sideimg: [
            u18_img,
            u19_img,
            u20_img,
        ],
        price: 2596,
        desc: `URSA Mini Foamies are soft foam mounts designed for small-diameter microphones like the DPA 6060, Sennheiser MKE1, Countryman B6, and Sanken COS11. Their flat sides allow them to be easily attached to skin or costumes, reducing clothing noise while providing a quiet buffer. They can also be placed on transmitter antenna tips to help minimize RF loss when pressed against the body. Made from high-quality sponge, they come in packs of 12 and are available in black, white, and beige.`,
    },
    {
        id: 29,
        category: "ursa",
        name: "Ursa Plush Sleeves",
        image:
            u21_img,
        price: 4130,
        desc: `URSA Plush Sleeves Plush Sleeves are a brand new 12mm length short fur LAV sleeve. Designed to use under costumes to help disguise mics, reduce clothing noise and protect the mic from light wind. 12mm width, super soft, re-useable lav mic covers. More about URSA Plush Sleeves Multipacks contain 1x White, 1x Black, 1x Beige. Single Colour Packs contain 3 of one colour. Available in 4 colours : Black, White, Beige & Brown. 12mm width, re-useable & super soft. Short Fur Sleeves for Light Wind Protection.`,
    },
    {
        id: 30,
        category: "ursa",
        name: "Ursa Tape (Soft Strips)",
        image:
            u22_img,
        sideimg: [
            u22_img,
            u24_img,
            u25_img,
            u33_img,
        ],
        price: 2360,
        desc: `URSA Tape Soft Strips (packs of 30) are perfect for securing mic cables, padding capsules, sticking mics to skin, or concealing gear. Available in beige, white, and jet black (woven finish), they blend seamlessly on skin, costumes, or shadows. Non-tearable, easy to cut with grid-lined backing. Roll size: 100 x 15 cm.`,
    },
    {
        id: 31,
        category: "ursa",
        name: "Ursa Pouch",
        image:
            u26_img,
        price: 3304,
        desc: `URSA Belt Pouches with Clips URSA Belt Pouches now come with a free removable Clip. These allow you to clip the pouch to any garment and hang it vertically or horizontally. Watch the Demo video here. URSA Pouches are low-profile soft pouches which allow you to rig a transmitter vertically or horizontally to URSA Belts, standard belts or bras. They can also be sewn or pinned into costumes. They can also be rigged on the inside of helmets, used as IEM pouches or just as soft protection if placing transmitters in the pocket. Available in Four Sizes & Two Colours Black & Beige. More About URSA Belt Pouches New Fabric Technology In order to make the most comfortable low-profile Pouches we developed a brand new bonded fabric. URSA Pouches are just 1mm thick. They provide excellent stretch, comfort & breathability with an outer surface that hook gripper can grip to at any point.`,
    },
    {
        id: 32,
        category: "ursa",
        name: "Ursa Mini Mount",
        image:
            u26_img,
        sideimg: [
            u26_img,
            u27_img,
            u28_img,
            u29_img,
        ],
        price: 2950,
        desc: `URSA MiniMounts MiniMounts are a slim, low-profile mount designed to be rigged where larger mounts cannot go. They are made from hardened plastic that does not deform or snap under pressure. Each mount is hand-finished to get the smoothest surface, allowing fabric to glide silently. MiniMounts are available in Two colours & designed specifically for DPA 4060, 4071, 6060, 4660HD, Sanken COS11 More About URSA MiniMounts Easy to rig beside buttons on shirts where larger mounts will not fit! Their thin shape makes them perfect mounts for rigging on the skin in the cleavage or onto the bra. Quick & Easy to wind protect using URSA Sticky Circles and Fur Circles. MiniMounts are moulded from hardened plastic. They won’t snap under pressure or deform under heat. Each MiniMount is hand finished to get the smoothest possible surface. This helps fabrics glide over the mount without creating friction and noise. Each pack comes with 5 free MiniMount Stickies. These stickies measure 11x 22mm and are designed specifically for MiniMount.`,
    },
    {
        id: 33,
        category: "ursa",
        name: "Ursa Soft Sleeves",
        image:
            u23_img,
        price: 3890,
        desc: `URSA Soft Sleeves Plush Sleeves are a brand new 12mm length short fur LAV sleeve. Designed to use under costumes to help disguise mics, reduce clothing noise and protect the mic from light wind. 12mm width, super soft, re-useable lav mic covers. More about URSA Soft Sleeves Multipacks contain 1x White, 1x Black, 1x Beige. Single Colour Packs contain 3 of one colour. Available in 4 colours : Black, White, Beige & Brown. 6mm width, re-useable & super soft. Low Profile Sleeves for Hiding LAV Mics`,
    },
    {
        category: "ursa",
        id: 34,
        name: "Ursa WIRERIG",
        image:
            u36_img,
        price: 4130,
        desc: `URSA WireRig transforms any lav mic into a flexible gooseneck, ideal for car rigs and plant mics. Its copper wire extends up to 40cm and locks using 8 base notches. Simply coil the mic cable, lock it in place, and bend for perfect positioning. The wire reduces noise transmission and supports wind protection like Bubblebee Windbubbles or Rycote Mini-Windjammers without issue. Each WireRig includes 20 “Very Stickies” for secure mounting. Dimensions: 35mm x 25mm x 8mm, wire length 40cm.`,
    },
    {
        id: 35,
        category: "ursa",
        name: "Ursa Tape Sticky Strips",
        image:
            u37_img,
        price: 2124,
        desc: `URSA Tape Hypoallergenic Sticky Strips - 60 Pack URSA Tape - Sticky Strips are a perfect replacement for alternatives like Topstick. They are made from the same tried and tested URSA Tape that makes other Stickies solutions like Sticky Circles and URSA MiniMount Stickies. They are hypoallergenic and safe to use against skin and also do not leave residue if used on costumes and delicate fabrics. Ideal for cutting to the length you need to mount your lavalier mic or other equipment. Available as a pack of 60 strips measuring 78mm x 22mm with easy to remove split backing.`,
    },
    {
        id: 36,

        category: "viviana",
        name: "Viviana Extreme Ankle Strap",
        image:
            v1_img,
        sideimg: [
            v1_img,
            v2_img,
        ],
        price: 5900,
        desc: `viviana Straps Extreme Features a unique hypoallergenic grip across the entire face of the strap, making it the most technologically advanced fabric made in Italy. Crucially, it maintains all the key elements of Viviana Straps: breathability, slimness, and softness. Viviana Straps are Machine Washable at 40-60 degrees Hang dry or Tumble dry at a low temperature.
Viviana Extreme Ankle Straps is low-profile, ultra-soft, and feature a custom-made foam layer that provides more protection to your TX, while being super-comfortable for talent to wear`,
    },
    {
        category: "viviana",
        id: 37,
        name: "Viviana Extreme Calf Strap",
        image:
            v3_img,
        price: 5900,
        desc: `Viviana Straps Extreme Features a unique hypoallergenic grip across the entire face of the strap, making it the most technologically advanced fabric made in Italy. Crucially, it maintains all the key elements of Viviana Straps: breathability, slimness, and softness. Viviana Straps are Machine Washable at 40-60 degrees Hang dry or Tumble dry at a low temperature.
Viviana Straps Extreme Calf Viviana Straps Extreme Calf features a unique double Velcro so you can decide whether to tighten on the bottom or top of the talent’s legs. Today, Viviana straps have the most advanced fabric technology available on the market that protects the expensive TX from sweat without undermining comfort and breath ability, a unique hypoallergenic grip spread all over the fabric that keeps the strap always in place and also a new design to guarantee the best comfort and performance for your talent.`,
    },
    {
        category: "viviana",
        id: 38,
        name: "Viviana Extreme Thigh Strap",
        image:
            v4_img,
        sideimg: [
            v4_img,
            v5_img,
        ],
        price: 5900,
        desc: `Viviana Straps Extreme Features a unique hypoallergenic grip across the entire face of the strap, making it the most technologically advanced fabric made in Italy. Crucially, it maintains all the key elements of Viviana Straps: breathability, slimness, and softness. Viviana Straps are Machine Washable at 40-60 degrees Hang dry or Tumble dry at a low temperature.
Viviana Extreme Thigh Strap for Shure ADX1M The Viviana Straps Extreme feature a unique hypoallergenic grip spread all over the fabric. This allows Viviana Straps Extreme to keep your transmitter safe and in place during any talent?s action and extreme scenes without undermining comfort. The new hypoallergenic grip is impossible to remove and it preserves the most important features of the Viviana Straps: breathability ? slimness and softness.
Size - 58cm`,
    },
    {
        category: "viviana",
        id: 39,
        name: "Viviana Extreme Waist Strap",
        image:
            v6_img,
        sideimg: [
            v6_img,
            v25_img,
        ],
        price: 5900,
        desc: `Viviana Straps Extreme Features a unique hypoallergenic grip across the entire face of the strap, making it the most technologically advanced fabric made in Italy. Crucially, it maintains all the key elements of Viviana Straps: breathability, slimness, and softness. Viviana Straps are Machine Washable at 40-60 degrees Hang dry or Tumble dry at a low temperature.
Viviana Extreme Waist Belt The Viviana Straps Extreme feature a unique hypoallergenic grip spread all over the fabric. This allows Viviana Straps Extreme to keep your transmitter safe and in place during any talent?s action and extreme scenes without undermining comfort. The new hypoallergenic grip is impossible to remove and it preserves the most important features of the Viviana Straps: breathability ? slimness and softness`,
    },
    {
        category: "viviana",
        id: 40,
        name: "Viviana Extreme Chest Strap",
        image:
            v8_img,
        price: 5900,
        desc: `Viviana Straps Extreme Features a unique hypoallergenic grip across the entire face of the strap, making it the most technologically advanced fabric made in Italy. Crucially, it maintains all the key elements of Viviana Straps: breathability, slimness, and softness. Viviana Straps are Machine Washable at 40-60 degrees Hang dry or Tumble dry at a low temperature.
Viviana Chest This strap allows talent to carry the lavs around the chest, thanks to a hypoallergenic grip that spans the full face of the fabric. The result? No more sticking the lav directly onto skin or chest hair-related noise. Not only is it comfortable and breathable, it comes with 3 different sleeves too, allowing you to carry The Naked lavs, big concealer, or the small concealer.
Size 106 CM`,
    },
    {
        category: "viviana",
        id: 41,
        name: "Viviana Pads (Pack of 30)",
        image:
            v10_img,
        sideimg: [
            v10_img,
            v26_img,
            v28_img,
        ],
        price: 3776,
        desc: `Viviana Pad The Viviana Pad is a multipurpose soft foam with hypoallergenic tape across one side. It’s your go-to for when you have to mic up, or for when you’ve miced up already. Use as a universal concealer foamie to create space between the lav and the fabric, place it behind a noisy object, or wrap it around the TX antenna for a quick-fix solution. Available in: 30 pcs per box`,
    },
    {
        category: "viviana",
        id: 42,
        name: "Viviana Dots (Round)",
        image:
            v12_img,
        price: 2360,
        desc: `Made from super-soft foam layered between ultra-adhesive, hypoallergenic tape, these stickers can be used on both skin and fabrics without leaving marks. The 1-millimeter foam gives a super-soft structure to the tape and creates a little layer between the fabric and lav, helping to reduce rustling noise. Available in three shapes: Round 2.2 x 2.2 cm (box of 30 pcs)`,
    },
    {
        category: "viviana",
        id: 43,
        name: "Viviana Skin (pack of 30 strips)",
        image:
            v13_img,
        price: 2360,
        desc: `Made from super-soft foam layered between ultra-adhesive, hypoallergenic tape, these stickers can be used on both skin and fabrics without leaving marks. The 1-millimeter foam gives a super-soft structure to the tape and creates a little layer between the fabric and lav, helping to reduce rustling noise. Available in three shapes: Round 2.2 x 2.2 cm (box of 30 pcs)`,
    },
    {
        category: "viviana",
        id: 44,
        name: "Viviana Beetle",
        image:
            v16_img,

        sideimg: [
            v16_img,
            v15_img,
        ],
        price: 3304,
        desc: `The Viviana Beetle is a new concept of low-profile concealer made using a unique plastic injection molding process, which guarantees top quality and strength. Not only is the Viviana Beetle a concealer, it’s also the core element of our modular concept. The Viviana Beetle can be paired with all Beetle accessories, from bra clips to vampire clips, providing maximum versatility in just one click. HIGHEST PERFORMANCE Be ready for any situation, and ensure top-quality sound, with the versatile Viviana Beetle. There are two Viviana Beetles on the market: BEETLE for SANKEN COS11`,
    },
    {
        category: "viviana",
        id: 45,
        name: "Viviana Beetle Bra Clip",
        image:
            v17_img,
        price: 3540,
        desc: `The Viviana Beetle can be paired with all Beetle accessories, from our bra clip to our vampire clip, guaranteeing maximum versatility in just one click. What’s more, all the Beetle accessories are compatible with all Beetle concealers.`
    },
    {
        category: "viviana",
        id: 46,
        name: "Viviana Fur For Lav",
        image:
            v19_img,
        price: 2950,
        desc: `Viviana “Fur For Lav” is a low-profile, super soft, high-density hair fur designed to protect lav mics from wind and reduce rustling noise. The unique feature of the soft high-density hair fur provides enhanced wind protection while preserving the natural sound, ensuring clear and natural audio from the lav mics. Available shapes: Round`,
    },
    {
        category: "viviana",
        id: 47,
        name: "Viviana Vampire",
        image:
            v22_img,
        price: 3540,
        desc: `The Viviana Beetle can be paired with all Beetle accessories, from our bra clip to our vampire clip, guaranteeing maximum versatility in just one click. What’s more, all the Beetle accessories are compatible with all Beetle concealers.`,
    },
    {
        category: "viviana",
        id: 48,
        name: "Viviana Puffy Pouch",
        image:
            v23_img,
        sideimg: [
            v23_img,
            v24_img,
        ],
        price: 3776,
        desc: `Viviana Skin is a moleskin made from a super-soft and stretchy fabric with hypoallergenic tape to one side. Use it to stick lavs onto skin and fabric to reduce rustling noise, without it leaving any marks. Also perfect for providing camouflage. In the box: 30 strips (2.2 x 8cm)`,
    },
    {
        category: "viviana",
        id: 49,
        name: "Viviana Tape",
        image:
            v30_img,
        price: 2124,
        desc: `Viviana Tape Hypoallergenic Double-Sided Clear Lavalier Tape - 60 Pack Perfect for use on skin and fabric, the Viviana Tape is a super-sticky, double-sided, hypoallergenic clear tape specifically designed to affix lavalier mics, concealers, and other accessories without leaving marks. This pack contains 60 strips, each measursing 8cm x 2cm in size.`,
    },
    {
        category: "viviana",
        id: 50,
        name: "Viviana Hook",
        image:
            v31_img,
        sideimg: [
            v31_img,
            v32_img,
            v33_img,
        ],
        price: 4484,
        desc: `Viviana Hook LIGHT & POWERFUL Designed for a quick and safe pick up and drop off, it’s made with aluminium, making it incredibly light and small at just 8cm long. It features a removable pin at the back, meaning it’s incredibly easy to set up, and holds up to 35 kg. THE BEST SCREW TIGHTEN THE NUT WITH A SCREWDRIVER The Viviana Screw works in tandem with the Viviana Hook.`,
    },
    {
        category: "hideamic",
        id: 51,
        name: "Hide-a-mic Bflex",
        image:
            h8_img,
        sideimg: [
            h8_img,
            h9_img,
            h10_img
        ],
        price: 3009,
        desc: `Available Colors :- Black and Beige

B_Flex for Sanken COS11 With the Hide-a-mic B_Flex you can apply a lavalier microphone directly to the body without worrying fabric touching the microphone. The Hide-a-mic B_Flex creates a physical space around the microphone for clear recordings. B_FLex is reusable and made of skin friendly silicone rubber. Easy to apply and easy to clean. Works with DPA 4060/4071, Countryman B3 and Sennheiser MKE`,
    },
    {
        category: "hideamic",
        id: 52,
        name: "Hide-a-mic Sticky Pads",
        image:
            h11_img,
        price: 1121,
        desc: `Sticky pads, super adhesive glue pad Stick pads. Thin, transparent, super strong, glue pads to secure microphone concealers, microphones or anything else you want to tack down.Noisy jewelry, keychains and zippers are easily secured with this almost invisible glue pad. 8 x 8 mm (0,3 X 0,3 inch). 40 in a pack. Leaves nu residue when removed.`,
    },
    {
        category: "hideamic",
        id: 53,
        name: "Hide-a-mic Set",
        image:
            h12_img,
        price: 5900,
        desc: `Available Color :- Transparent

HIDE A MIC SET FOR LAVALIER With the Hide-a-mic concealer sets you can easily hide a Sanken COS11 microphones under any piece of clothing without scratching or other disturbing sounds for clear recordings. Hide-a-mic concealers stand out because they create a physical space around the microphone that prevents anything from touching the microphone. A set contains 4 different clips with each their own use. You can choose for the Tie-holder, Shirt-holder, T-shirt-holder and Bra-holder. The clips in this concealer set will work for you in almost every situation and with the included plastic case it will be a great addition to your kit. DPA 4060/71 DPA 6060/61 SANKEN COS 11 COLOUR: TRANSPARENT`,
    },
    {
        category: "hideamic",
        id: 54,
        name: "Hide-a-mic Foam-O-Pad",
        image:
            h13_img,
        sideimg: [
            h13_img,
            h14_img,
            h15_img,
            h16_img,
        ],
        price: 2183,
        desc: `Hide-a-mic Foam-o-pad The Foam-o-pad is a versatile, oval-shaped, 3mm soft sponge pad with a sticky backing. Made from the highest quality make-up sponge used by artists worldwide, it ensures optimal performance. The sticky backing is from high grade, hypoallergenic 3M tape with exactly the right strength of stick to it and easy to cut. You can use the Foam-o-pad e.g. to create space around your microphone, protect a microphone concealer against scratching and unwanted noises or create your own low profile foam concealer. All for achieving clear recordings. Each bag contains 16 pieces and is available in five color variations: black, white, brown, beige and mix.`,
    },
    {
        category: "hideamic",
        id: 55,
        name: "Hide-a-mic Foam-o-Regular",
        image:
            h17_img,
        sideimg: [
            h17_img,
            h18_img,
            h20_img,
            h19_img
        ],
        price: 2183,
        desc: `Available Colors :- Multicolor and Black

Hide-a-mic Foam-O’s Universal Microphone Mounts Hide-a-mic Foam-O’s — Soft foam universal microphone mounts. 16 pieces per package. Low profile and latex free. Helps prevent unwanted noise in your recordings. Available Colors Black, White, Beige, Brown, and Multi-Pack (with 4 of each color) Available Sizes Small Compatible with DPA 606X, 407X, Sennheiser MKE1, Countryman B6, etc. Regular Compatible with Sanken COS 11, DPA 406X, 407X, Sennheiser MKE2, ME2, Countryman B3, etc.`,
    },
    {
        category: "hideamic",
        id: 56,
        name: "Hide-a-mic Hair Clipz",
        image:
            h21_img,
        sideimg: [
            h21_img,
            h22_img,
            h23_img,
            h24_img,
        ],
        price: 2360,
        desc: `HIDE A MIC HAIR CLIPZ Sometimes a good option is to place your lavalier microphone in hair or in a wig. With Hide-a-mic Clipz you can mount your microphone easy, safe and quick. Clipz is a small 24 mm hair clip that is mounted with an elastic band . There are 3 clips in a set. 1 to mount the microphone and 2 to guide the cable to the back of the head. Great for film, television and theater use. COLOUR: BLACK`,
    },
    {
        id: 57,
        category: "home",
        name: "Hide-a-mic Silencer set",
        image: [
            h1_img,

        ], sideimg: [
            e2_img,
            e3_img
        ],
        price: 2950,
        desc: `HIDE A MIC BRA HOLDER As a soundmixer you are always busy looking for the best place to hide a miniature microphone. The bra is usually a great place to hide microphones but nowadays placing microphones there can be a charged topic. It can cause awkward situations for both the female talent/host and the sound mixer on duty. The Hide-a-mic Bra-clip can easily be self-applied by the talent/host and will produce clear sound for your recordings throughout the day; without any need for adjustments. No more awkward situations, insinuations and expectations on set, exactly how it’s should be in a professional environment DPA 4060/71 DPA 6060/61 SANKEN COS 11`,

    },
    {
        id: 58,
        category: "home",
        name: "Hide-a-mic Tie Holder",
        image: [
            e4_img,
        ],
        price: 2596,
        desc: `Available Colors :- Black and Transparent
    
    Tie-holder – The Tie-holders is the basis of Hide-a-mic. You run the microphone from the back of the tie down through the knot. Then apply the holder and push it back in the knot. Secure it with a Hide-a-mic Sili-pad and you are ready to roll.1
    `,
    },
    {
        id: 59,
        category: "home",
        name: "Hide-a-mic bra-holder",
        image: [
            e34_img,

        ],
        sideimg: [
            e10_img,
            e12_img,
        ],
        price: 2596,
        desc: `Available Colors :- Black and Beige
    
    B_Flex for Sanken COS11 With the Hide-a-mic B_Flex you can apply a lavalier microphone directly to the body without worrying fabric touching the microphone. The Hide-a-mic B_Flex creates a physical space around the microphone for clear recordings. B_FLex is reusable and made of skin friendly silicone rubber. Easy to apply and easy to clean. Works with DPA 4060/4071, Countryman B3 and Sennheiser MKE`,
    },
    {
        id: 60,
        category: "home",
       name: "Mini-alto 180 & RAD-2 Kit",
        image:
            w8_img,
        sideimg: [
            w3_img,
            w2_img,
            w5_img,
            w7_img
        ],
        price: 60180,
        desc: `Mini-ALTO & RAD-2 Kit is a compact, professional windshield and shock mount system for small and shotgun mics. It includes the RAD-2 shock mount for superior noise isolation, a lightweight 2-part magnetic pod windshield, and a removable fur cover offering up to -40dB wind reduction. At just 85mm in diameter, it’s the smallest full-coverage zeppelin available, yet performs like larger models. The kit comes with the windshield, RAD-2 mount, four suspension hoop sets, fur cover, “smiley face” adaptor, magnetic stowage holder with carabiner, RAD cable straps, and optional custom XLR cable. Compatible with mics like DPA4017C, Neumann KM184, Rode NT5, Sanken CS-M1, Schoeps CMC series, and Sennheiser MKH50. Made in the U.K.`,
    },
    {
        id: 61,
        category: "home",
        name: "Mini-alto 210 & RAD-2 Kit",
        image:
            w1_img,
        sideimg: [
            w3_img,
            w8_img,
            w5_img,
            w7_img
        ],
        price: 60180,
        desc:`Mini-ALTO & RAD-2 Kit is a lightweight, professional windshield and shock mount system for small, short, and standard shotgun mics. It includes the award-winning RAD-2 shock mount, a quick-fit 2-part magnetic pod windshield, and a removable fur cover that delivers up to -40dB wind reduction. At just 85mm in diameter, it’s the smallest full-coverage zeppelin available, combining compact size with pro-level performance. The kit features the windshield, RAD-2 mount with 4 suspension hoop sets, fur cover, “smiley face” adaptor, magnetic stowage holder with carabiner, RAD cable straps, and optional custom 3-pin XLR cable. Compatible with mics like DPA 2017, Sanken CS-1e, and Sennheiser MKH8060. Made in the U.K.`
    },
    {
        id: 62,
        category: "home",
        name: "12cm Shotgun Mic Foam (19/22)",
        image:
            w9_img,
        sideimg: [
            w9_img,
            w11_img,
            w10_img,
        ],
        price: 2950,
        desc: `2cm Shotgun Mic Foam (19/22) by Radius is a high-quality acoustic foam designed to block plosives, swooshes, and light wind noise without affecting high frequencies. Made in the U.K. from durable semi-open cell material, it resists UV and moisture, unlike cheap foams that degrade quickly. The tapered design offers extra side protection near the capsule while maintaining transparency at the front. Compatible with 19–22mm diameter short shotguns and camera mics (slots <12cm from the end), including models from Audio Technica, DPA, Schoeps, Sennheiser, and Sony. Specs: external length 150mm, internal length 120mm, width 55mm.`,
    },
    {
        id: 63,
        category: "home",
        name: "12cm Shotgun Mic Foam (15cm)",
        image:
            w12_img,
        sideimg: [
            w12_img,
            w11_img,
            w13_img,
        ],
        price: 2950,
        desc:`15cm Shotgun Mic Foam (19/22) from Radius is crafted from premium acoustic foam to reduce plosives, boom swooshes, and light wind noise while preserving high-frequency clarity. Made in the U.K. with UV- and moisture-resistant semi-open cell material, it’s far more durable than standard foams. The tapered design offers added side protection near the capsule and transparency at the interference tube. Suitable for 19–22mm shotgun mics with slots <15cm from the end, including Audio-Technica AT897/BP4029, Neumann KMR 81i, Rode NTG-1/NTG-2, Sanken CS-1e/CSS-50, Sennheiser MKE600, and Schoeps CMIT 5.`
    },
    {
        id: 64,
        category: "home",
        name: "MKH 50 ",
        image:
            w15_img,
        sideimg: [
            w15_img,
            w16_img,
            w17_img,
        ],
        price: 2360,
        desc:`MKH50 Mic Foam by Radius is a premium acoustic foam designed to block plosives, swooshes, and light wind noise without compromising high-frequency clarity. Made in the U.K. from UV- and moisture-resistant semi-open cell material, it’s far more durable than standard foams. The tapered design enhances side protection near the capsule while maintaining transparency at the front. Fits Sennheiser MKH20/30/40/50 and Sony ECM-MS2, as well as other 24–25mm small pencil condenser and instrument mics with slots under 5cm from the tip.`
    },
    {
        id: 65,
        category: "home",
        name: "Ursa Chest Strap",
        image:
            u4_img,
        sideimg: [
            u4_img,
            u35_img
        ],
        price: 5192,
        desc:`URSA Straps Chest Strap for Lavalier URSA Chest Straps allow you to rig microphones onto sweaty or hairy chests which would otherwise not take sticky tape. Our unique polyurethane gripper is bonded on to keep the straps from slipping. We also utilise a Cable Keeper which keeps your cable firmly in place without needing to tape it to the strap. In order to make the most comfortable low-profile straps URSA developed a brand new bonded fabric. URSA straps are just 1mm thick. They provide excellent stretch, comfort and breathability with an outer surface that hook Velcro can grip to at any point. Available in Beige colour only Designed to fit most popular lavalier microphones Unique polyurethane gripper keeps the strap from slipping Built-in cable pocket secures your looped cable Ultra low profile fabric is only 1mm thick`
    },
    {
        id: 66,
        category: "home",
        name: "Top Stick",
        image: [
            e55_img,

        ],
        price: 1416,
        desc: `Vapon Topstick is a double-sided, Double Sided adhesive tape that can be used to hold wigs but also works for other applications. This double sided, non-toxic, surgical quality tape is easily removed and kind to your skin. Size:- 1"×3" 50 Strips`,
    },
    {
        id: 67,
        category: "home",
        name: "Sensi Tak Roll",
        image: [
            e56_img,
        ],
        price: 1888,
        desc: `This double sided, non-toxic, surgical quality tape is easily removed and kind to your skin. Size:- 1"x 12 YDS`,
    },
    {
        id: 68,
        category: "home",
        name: "Toupee Tape",
        image: [
            e53_img,
        ],
        price: 1475,
        desc: `Toupee Tape Transparent Tape Roll Specially developed for wigs and toupees, but also works for other applications. This double sided, non-toxic, surgical quality tape is easily removed and kind to your skin. Size:- 1" Roll (x1) - 25mm width x 5m length`,
    },
    {
        id: 69,
        category: "home",
        name: "Viviana Tape",
        image: [
            e42_img,
        ],
        price: 1770,
        desc: `Viviana Tape Hypoallergenic Double-Sided Clear Lavalier Tape - 60 Pack Perfect for use on skin and fabric, the Viviana Tape is a super-sticky, double-sided, hypoallergenic clear tape specifically designed to affix lavalier mics, concealers, and other accessories without leaving marks. This pack contains 60 strips, each measursing 8cm x 2cm in size.`,
    },
    {
        id: 70,
        category: "home",
        name: "Viviana Vampire",
        image: [
            e45_img,
        ],
        price: 2950,
        desc: `The Viviana Beetle can be paired with all Beetle accessories, from our bra clip to our vampire clip, guaranteeing maximum versatility in just one click. What’s more, all the Beetle accessories are compatible with all Beetle concealers.`,
    },
    {
        id: 71,
        category: "home",
        name: "Viviana Extreme Calf Strap",
        image: [
            e36_img,
        ],
        price: 5590,
        desc: `Viviana Straps Extreme Features a unique hypoallergenic grip across the entire face of the strap, making it the most technologically advanced fabric made in Italy. Crucially, it maintains all the key elements of Viviana Straps: breathability, slimness, and softness. Viviana Straps are Machine Washable at 40-60 degrees Hang dry or Tumble dry at a low temperature.
    Viviana Straps Extreme Calf Viviana Straps Extreme Calf features a unique double Velcro so you can decide whether to tighten on the bottom or top of the talent’s legs. Today, Viviana straps have the most advanced fabric technology available on the market that protects the expensive TX from sweat without undermining comfort and breath ability, a unique hypoallergenic grip spread all over the fabric that keeps the strap always in place and also a new design to guarantee the best comfort and performance for your talent.`,
    },
    {
        id: 72,
        category: "home",
        name: "BongoTies",
        image: [
            e51_img,

        ],
        sideimg: [
            e52_img,
            e51_img,
        ],
        price: 1416,
        desc: `BongoTies Elastic Cable Ties Highlights Cable Ties for Professional or Home Use Elastic Rubber & Bamboo Construction Patented Closing Mechanism Pack of 10 Features This pack of 10 black BongoTies is suitable for pro audio, video, photo, or any other application in which you'd need to keep coiled cables from unwinding into a mess of tangled spaghetti. These ties are fashioned of rubber and bamboo, are elastic in nature, and feature a patented button-type closing construction. Each tie is 5" long.`,
    },
    {
        id: 73,
        category: "home",
        name: "SANKEN COS-11D",
        image: c1_img,
        price: "contact for best prices",
        desc: `HIDE A MIC BRA HOLDER The new generation COS-11D ultra-miniature lavalier was designed to meet today’s HD audio standards while providing greater immunity to RF interference. The COS-11D is available in four colors (Black, White, Gray, and Beige) and with many connectivity options and accessories. It features a front mesh screen which is water resistant, better protecting the microphone from perspiration and cosmetics, and is ideal for outdoor shooting in foul weather. The mic includes an exclusive vertical placement of the diaphragm for a much greater effective area within an extremely small casing. Sanken has combined extensive R&D with the world’s most advanced precision craftsmanship for the ultimate in sensitivity and natural sound.`,
    },
    {
        id: 74,
        category: "home",
        name: "ORCA OR-34 AUDIO MIXER BAG",
        image: [
            c2_img,

        ],
        sideimg: [
            c3_img,
            c4_img
        ],
        price: "OUT OF STOCK",
        desc: `OR-34 AUDIO MIXER BAG Main Features: Inside lining made from bright blue brushed polyester for easy equipment viewing External aluminum frame and internal honeycomb frame for maximum gear protection Ventilated using EVA foam Unique battery pocket with extra rubber battery fittings Two large pockets for audio accessory storage Four detachable external pouches and nine rubber bands to hold wireless systems of any size Detachable carrying handles and shoulder strap Front bungee cords to hold boom pole or cables Can be connected to an Orca harness to ease user’s load Orca “lifts” that can be used to adjust mixer height within the bag Unique sliding system to help secure and position mixer inside the bag Transparent TPU top cover for easy equipment viewing Easy equipment access from all six directions Model Internal: cm / Inch External: cm / inch Weight: Kg / Lb OR-34 L: 33cm / 12.99" W: 19cm / 7.48" H: 23cm / 9.05" L: 39cm / 15.35" W: 33cm / 12.99`,
    },
    {
        id: 75,
        category: "home",
        name: "Mic Drop for TA5 Connector",
        image:
            e54_img,
        price: 1416,
        desc: `An excellent wiring solution. Made from stainless steel. It is designed to be a less intrusive way to wire talent. Simply attach your adapter, plug in your lavalier and drop it down t-shirts or loose clothing to get the job done faster.`,
    },{
        id: 76,
        category: "home",
        name: "Viviana Hook",
        image: [
            v31_img,

        ],
        sideimg: [
            v32_img,
            v33_img,
            v31_img,
        ],
        price: "4484",
        desc: `Viviana Hook LIGHT & POWERFUL Designed for a quick and safe pick up and drop off, it’s made with aluminium, making it incredibly light and small at just 8cm long. It features a removable pin at the back, meaning it’s incredibly easy to set up, and holds up to 35 kg. THE BEST SCREW TIGHTEN THE NUT WITH A SCREWDRIVER The Viviana Screw works in tandem with the Viviana Hook.
`,
    },
    {
        category: "radius",
        id: 77,
        name: "Mini-ALTO 180 Add-On Kit",
        image:
            w33_img,
        sideimg: [
            w33_img,
            w34_img,
            w35_img,
        ],
        price: 53100,
        desc: `The Mini-ALTO Windshield 180 Add-On Kit is made to be fitted on top of any existing RAD-1, RAD-2 or RAD-3 shock mount for small condenser microphones. This kit includes an ultra-lightweight 2-part magnetic "pod" windshield, a Smiley Face Adaptor that connects to the RAD shock mount, a removable fur windcover, and a magnetic Windshield Stowage Holder with Carabiner Clip.
The Mini-ALTO windshield system has been designed to be fast and easy-to-use with almost all small condenser, short shotgun and standard shotgun sized microphones. With a diameter of just 85mm, the Mini-ALTO is the smallest "full-coverage" zeppelin windshield available in the professional audio recording industry. Even at this size, the Mini-ALTO will achieve wind reduction for up to -40dB with its included fur cover, which is comparable to larger pill-shaped windshields.
Included in kit: Mini-ALTO 180 size windshield, Fur Windcover, Smiley Face Adaptor, Magnetic Windshield Stowage Holder with Carabiner Clip and a Pair of RAD Cable Straps
Fits: DPA4017C; Neumann KM 184; Rode NT5; Sanken CS-M1, CMS-50; Schoeps CMC6 Series; CMD42/MK41; MiniCMIT; CMC1U-KMIT; Sennheiser MKH50`,
    },
    {
        category: "radius",
        id: 78,
        name: "Mini-ALTO 115 Add-On Kit",
        image:
            w36_img,
        sideimg: [
            w36_img,
            w37_img,
            w38_img,
        ],
        price: 53100,
        desc: `The Mini-ALTO Windshield 115 Add-On Kit is made to be fitted on top of any existing RAD-1, RAD-2 or RAD-3 shock mount for small condenser microphones. This kit includes an ultra-lightweight 2-part magnetic "pod" windshield, a Smiley Face Adaptor that connects to the RAD shock mount, a removable fur windcover, and a magnetic Windshield Stowage Holder with Carabiner Clip.
The Mini-ALTO windshield system has been designed to be fast and easy-to-use with almost all small condenser, short shotgun and standard shotgun sized microphones. With a diameter of just 85mm, the Mini-ALTO is the smallest "full-coverage" zeppelin windshield available in the professional audio recording industry. Even at this size, the Mini-ALTO will achieve wind reduction for up to -40dB with its included fur cover, which is comparable to larger pill-shaped windshields.
Included in kit: Mini-ALTO 115 size windshield, Fur Windcover, Smiley Face Adaptor, Magnetic Windshield Stowage Holder with Carabiner Clip and a Pair of RAD Cable Straps
Fits: DPA 4018C; Neumann KM 100 Series; Schoeps CMC1 Series; Sennheiser MKH8020; MKH8030; MKH8040; MKH8050`,
    },
    {
        category: "radius",
        id: 79,
        name: "Pair of RAD MKH50 Mic Clips (Clips Only - No Hoops)",
        image:
            w39_img,
        sideimg: [
            w39_img,
            w40_img,
        ],
        price: 4130,
        desc: `Pair of RAD Mount MKH square style mics clips to fit Sennheiser MKH20, MKH30, MKH40, MKH50 & MKH60. Each clip comes with a safety strap.
Each clip fits each hoop we have for the RAD-1, RAD-2 & RAD-3 shock mounts.`,
    },
    {
        id: 80,
        category: "ursa",
        name: "Ursa Foamie Sleeves",
        image:
            u43_img,
        sideimg: [
            u42_img,
            u43_img,
            u44_img,
            
        ],
        price: 2360,
        desc: `Keep your lavalier microphones protected, discreet, and noise-free with URSA Foamie Sleeves. Each pack includes 12 premium foam sleeves, designed to fit snugly around all 3–5mm diameter lav mics.
The soft, silent foam reduces clothing rustle and allows mics to move naturally with the talent, making them ideal for tie rigs, shirt mounts, and hidden costume placements. Lightweight and flexible, they slide easily onto your mic and can even be cut to size for custom setups.
Perfect for film, TV, theatre, and live performance, URSA Foamie Sleeves are available in Black, White, and Caramelto blend seamlessly with wardrobe and stay invisible on camera.`,
    },
     {
        id: 81,
        category: "ursa",
        name: "Ursa Foamie Pads",
        image:
            u45_img,
        sideimg: [
            u45_img,
            u46_img,
            u47_img,
            u48_img,
            
        ],
        price: 2596,
        desc: `Reduce unwanted clothing noise and keep lavalier microphones secure with URSA Foamie Pads. Each pack includes 15 premium foam pads with medical-grade sticky tape for safe, reliable mounting directly onto clothing, costume fabric, or accessories.

The 3x2cm pads create a soft, padded layer around the microphone, helping to prevent clothing rustle and vibration from zips, buttons, or hats. Simply peel, place the lav mic on one side of the pad, fold over, and stick — quick to apply and discreet in use.

Lightweight and versatile, Foamie Pads can be mounted inside shirts, ties, jackets, hats, or costume seams, giving sound teams a fast, dependable option for clean audio on set. Available in Black, White to blend with wardrobe and remain invisible under clothing.`,
    },
     {
        id: 82,
        category: "ursa",
        name: "Soft Soles & Heavy Duties - Multipack",
        image:
            u51_img,
        sideimg: [
            u50_img,
            u51_img,
            u49_img,
            u52_img,
            
        ],
        price: 4956,
        desc: `The URSA Soft Soles Multipack is an on-set essential for location sound professionals — designed to silence shoes quickly and reliably.
        What’s Inside
20 pre-cut shapes ready to apply.
2 sheets of Soft Soles (front pads).
2 sheets of Heavy Duties (heel pads).
4 High Heels Strips
2 x Small, Medium, Large Pre-cut Uppers & Heels.
Soft Soles Shapes

3mm soft padded foam reduces footstep noise.
Durable, strong, and flexible — won’t crumble or tear.
Non-squeak surface with high-grip backing.
Residue-free adhesive peels off cleanly in one piece.
Backing paper can be written on for easy trimming.
Heavy Duty Shapes

Designed for high-impact heel areas.
Silicone–foam sandwich for maximum durability & grip.
Retains grip & stick outdoors and in wet conditions.
Excellent grip and long-lasting wear.
Why Soft Soles?

Fast to apply, no wasted time on set.
Durable all-day performance indoors or out.
Custom foam solution made specifically for film and TV sound.
Whether you’re working on a drama, commercial, or reality shoot, Soft Soles and Heavy Duties are an essential part of any location sound toolkit. They’re quick to apply, easy to remove, and built to last — keeping your set silent, efficient, and professional.`,
    },
    {
        id: 83,
        category: "ursa",
        name: "Ursa PREMIUM Sticky Circles",
        image:
            u56_img,
        sideimg: [
            u56_img,
            u57_img,
            u58_img,
            
        ],
        price: 3127,
        desc: `URSA Premium Sticky Circles are designed for secure, discreet mic placement under clothing. At just 0.5mm thin, these padded stickies use premium foam to create a soft barrier between lavalier microphones and fabric, helping to reduce clothing rustle and unwanted noise.
Each 24mm pre-cut circle includes a small peel-off tab for quick and easy use on set. The hypoallergenic adhesive is safe for skin and clothing, leaving no residue when removed.
Compatible with URSA Circles, MiniMounts, and a wide range of lav mic mounts, these stickies provide a reliable hold while maintaining comfort for the wearer. Perfect for film, TV, and theatre productions where clean audio and quick rigging are essential.
Key Features:
60x Premium Sticky Circles (24mm diameter)
Low profile – just 0.5mm thin for discreet placement
Padded premium foam reduces clothing noise
Hypoallergenic & safe on skin and fabrics
Residue-free adhesive – clean removal after use
Quick peel tabs for fast application on set
Works with URSA Circles, LAV Mounts & MiniMounts`,
    },
     {
        id: 84,
        category: "ursa",
        name: "Ursa Heat Shields",
        image:
            u59_img,
        sideimg: [
            u59_img,
            u60_img,
        ],
        price: 2065,
        desc: `Transmitters can generate a lot of heat, especially when on a high power, which can become uncomfortable for actors.
URSA Heat Shields are designed as a quick on-set solution to keep your cast comfortable and the cameras rolling.
Made from a Premium Heat Resistant Foam which reduces the radiation of heat from a transmitter to the body by up to 40%.
Heat Shields are durable, stretchy and soft to the touch & their closed-cell structure ensures excellent insulation with a low-profile depth of just 4mm.`,
    },
    {
        id: 85,
        category: "ursa",
        name: "URSA Cases - Zipper Case",
        image:
            u61_img,
        sideimg: [
            u62_img,
            u61_img,
            u63_img,
        ],
        price: 649,
        desc: `Fit up to 8 URSA Straps in one Case. 
Very handy for storing and organising your URSAs. 
Seen here stored using gripper on the lid of a radio mic box. Each case stores a different size of strap. 
Each URSA Zipper Case comes with an URSA Colour Chart Card & a fancy URSA Sticker. 
Dimensions : 203 x 127mm (8×5″)`,
    },
    {
        category: "radius",
        id: 86,
        name: "Pair of RAD MS Double Mic Clips",
        image:
            w41_img,
        sideimg: [
            w41_img,
            w42_img,
            w43_img,
        ],
        price: 5310,
        desc: `Pair of MS Double Mic Clips suitable for mounting 19-21mm mic pairs in mid-side stereo configuration. These clips space MS paired mics at a very close 2.5mm apart and have adjustment screws for lower mic clips to get perfect vertical alignment. The clips come with safety straps to hold both mics in place, as well as a pair of 8mm inserts for holding MZL or Lemo connectors in the rear mic clips. The clips come in 2 sizes: MS19 for 19mm diameter microphones and MS20 for 20-21mm microphones.

Double mic clips for MS pairs of mics 19-21mm in diameter
Can be used on RAD-2 or RAD-3 mounts and inside Mini-ALTO windshield kits 
Mic clips have vertical alignment adjustment screws and safety straps to hold both mics in place
Comes with a pair of 8mm inserts for use with MZL or Lemo connectors in the rear mic clips
MS19 (dark blue colour) Fits: Sennheiser MKH8030/80X0; and other 19mm diameter microphone pairs
MS20 (light blue colour) Fits: Schopes CCM MS pairs, CMC1 MS pairs, CMC6 MS pairs, MiniCMIT/CCM pair; and other 20-21mm microphone pairs`,
    },
    {
        category: "radius",
        id: 87,
        name: "RAD Mount Replacement 360 XLR Holder",
        image:
            w45_img,
        price: 3540,
        desc: `Replacement 360-degree XLR holder attachment for RAD mount boom adaptor.

Removable from RAD mount boom adaptor.
Unique design only works with RAD Mount boom adaptors.
Snugly holds the XLR stem with a thumbwheel screw to tightly lock in place.`,
    },
    {
        category: "radius",
        id: 88,
        name: "RAD Mount Boom Adaptor w/ 360 XLR Holder",
        image:
            w46_img,
        price: 4484,
        desc: `RAD Mount boom adaptor with 360 XLR holder can be purchased as a replacement for a RAD-1/2 or to convert a RAD-3 mount into a a boom mount without the handle. 
Boom adaptor works with all RAD mounts. Simply screw on using the thumbwheel attached to the RAD top bracket.
Comes with 360-degree XLR holder
3/8 threaded base to fit on boom poles or stands
XLR holder turns in both directions. Screw tightly onto boom pole or stand to lock it into place.
Bottom boom mount adaptor and XLR holder only. Other RAD mount parts sold separately.`,
    },
    {
        category: "radius",
        id: 89,
        name: "RADIUS WIND COVER FUR",
        image:
            w47_img,
        sideimg: [
            w48_img,
            w47_img,
        ],
        price: 12980,
        desc: `RADIUS WIND COVER FUR Replacement fur windcovers for Rycote ws kit 2`,
    },
    {
        id: 90,
        category: "home",
        name: "Red tape",
        image:
            e61_img,
        price: 590,
        desc:`Double sided tape 
Made in india. `
    },

    
]

export default all_product